import React from 'react';
import { Avatar, Chip, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

const formatDate = (value) => (value ? dayjs(value).format('DD MMM YYYY') : '—');

/**
 * columns for the milestone achievements table.
 * ONE ROW IS ONE MILESTONE AWARDED TO ONE EMPLOYEE.
 * @author Akhil E M
 * @createdAt 27-08-2026
 * @updates 27-08-2026(Akhil EM),
 * @type function
 * @returns {array}
 */
export const MilestoneTableHeader = () => [
  { field: 'sl_no', headerName: 'Sl No', width: 90 },
  {
    field: 'user_name',
    headerName: 'Employee',
    width: 260,
    renderCell: ({ row }) => (
      <Stack direction="row" spacing={1.25} alignItems="center" sx={{ minWidth: 0 }}>
        <Avatar src={row?.user_photo_url || undefined} sx={{ width: 30, height: 30 }}>
          {row?.user_name?.[0] ?? '?'}
        </Avatar>
        <Stack spacing={0} sx={{ minWidth: 0 }}>
          <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>
            {row?.user_name ?? '—'}
          </Typography>
          {row?.user_emp_id ? (
            <Typography variant="caption" sx={{ color: 'text.secondary' }} noWrap>
              {row.user_emp_id}
            </Typography>
          ) : null}
        </Stack>
      </Stack>
    ),
  },
  { field: 'milestone_title', headerName: 'Milestone Title', width: 240, toolTipGetter: true },
  { field: 'milestone_description', headerName: 'Description', width: 300, toolTipGetter: true },
  {
    field: 'milestone_reward',
    headerName: 'Reward',
    width: 190,
    renderCell: ({ row }) =>
      row?.milestone_reward ? (
        <Chip size="small" variant="outlined" label={row.milestone_reward} />
      ) : (
        <Typography variant="caption" sx={{ color: 'text.disabled' }}>
          —
        </Typography>
      ),
  },
  {
    field: 'date_of_publish',
    headerName: 'Date of Publish',
    width: 160,
    renderCell: ({ row }) => formatDate(row?.date_of_publish),
  },
  {
    field: 'announcement_status',
    headerName: 'Status',
    width: 165,
    //A MILESTONE IS ANNOUNCED TO EVERY EMPLOYEE ONCE ITS PUBLISH DATE ARRIVES , SO WHAT
    //MATTERS HERE IS WHETHER THAT DATE HAS PASSED — NOT WHO HAS SEEN IT.
    renderCell: ({ row }) => {
      if (!row?.date_of_publish) return '—';
      const announced = !dayjs(row.date_of_publish).isAfter(dayjs(), 'day');
      return (
        <Chip
          size="small"
          variant="outlined"
          color={announced ? 'success' : 'default'}
          label={announced ? 'Announced' : 'Scheduled'}
        />
      );
    },
  },
  {
    field: 'edit',
    headerName: 'Edit',
    type: 'action',
    actionType: 'edit',
    actionKey: 'editMilestone',
    width: 140,
    buttonName: 'Edit',
  },
  {
    field: 'delete',
    headerName: 'Delete',
    type: 'action',
    actionType: 'delete',
    actionKey: 'deleteMilestone',
    width: 150,
    buttonName: 'Delete',
  },
];
